export default __webpack_public_path__ + "static/media/file-tender-hammer.6062d5c0.svg";